import * as ActionTypes from './ActionTypes';

export const AddMenuHeadingAction = (params) => {
    return {
        type: ActionTypes.ATS_MENU_HEADING,
        params
    }
}
export const setSelectedMenuPathAction = (path) => {
    return {
      type: ActionTypes.SET_SELECTED_MENU_PATH,
      payload: path
    };
  };